import { useState } from "react";
import { useFeatureFlagEnabled } from "@posthog/react";
import { Clock } from "lucide-react";
import { ScheduleModal } from "./schedule-modal";

interface ScheduleFooterButtonProps {
  entityType?: string;
  disabled?: boolean;
  loading?: boolean;
  onSchedule: (scheduledAt: Date) => void | Promise<void>;
}

export function ScheduleFooterButton({
  entityType,
  disabled = false,
  loading = false,
  onSchedule,
}: ScheduleFooterButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isEntitySchedulingFlag = useFeatureFlagEnabled(
    "enable-entity-scheduling",
  );
  const isEntitySchedulingEnabled = isEntitySchedulingFlag === true;

  if (!isEntitySchedulingEnabled) {
    return null;
  }

  const handleSchedule = async (scheduledAt: Date) => {
    await onSchedule(scheduledAt);
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        disabled={disabled || loading}
        className="flex w-full items-center justify-center gap-2 text-sm text-gray-600 hover:text-gray-900 disabled:opacity-50"
      >
        <Clock className="h-4 w-4" />
        Schedule
      </button>
      <ScheduleModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSchedule={handleSchedule}
        entityType={entityType}
        loading={loading}
      />
    </>
  );
}
